import { DiscussionCard } from '@/components/discussion-card';
import { DiscussionsSkeleton } from '@/components/discussions-skeleton';
import React from 'react';

interface DiscussionListProps {
  categories: {
    value: string;
    label: string;
    description?: string;
  }[];
  isLoading?: boolean;
}

export const DiscussionList = ({
  categories,
  isLoading,
}: DiscussionListProps) => {
  return (
    <div className="grid grid-cols-3 gap-4">
      {isLoading && categories.length === 0 ? (
        <DiscussionsSkeleton />
      ) : (
        categories.map((category) => (
          <DiscussionCard key={category.value} category={category} />
        ))
      )}
    </div>
  );
};
